
import React from 'react';
import { Message } from '../../../messages/models';

const ErrorMessage: React.FC<{ message: Message }> = ({ message: { nickname, text }}) => (
  <div className="chat-message author-error">
    <p className="author">{nickname}</p>
    <p className="message-text">{text}</p>
  </div>
);

export default ErrorMessage;
